// extracted by mini-css-extract-plugin
export default {"menuBlock":"fE-z","title":"gE-z","nav":"hE-z","flexCell":"iE-z","facetLink":"jE-z"};